import React from 'react';

// Icons
import ArrowsUpRightIcon from 'relements/build/esm/ui/icons/ArrowsUpRightIcon';
import PressIcon from 'relements/build/esm/ui/icons/PressIcon';

export const KEYBOARD_SHORTCUTS_LIST = [
  {
    icon: <PressIcon size="big" />,
    title: 'Multiple Selection',
    subtitle: `${
      navigator?.userAgent?.indexOf('Mac') !== -1
        ? '⌘ CMD + Click, or ⌘ CMD + Click + Drag'
        : 'Ctrl + Click, or Ctrl + Click + Drag'
    }`,
    key: 'selection',
    separator: true,
  },
  {
    icon: <ArrowsUpRightIcon />,
    title: 'Create Connections',
    subtitle: '⇧ Shift + Click + Drag',
    key: 'connection',
  },
];

export default { KEYBOARD_SHORTCUTS_LIST };
